'use client';

import { Settings, PenLine, MapPin, TrendingUp, Rocket, DollarSign } from 'lucide-react';
import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

const steps = [
  { label: 'Technical SEO Foundation', detail: 'Site speed, mobile-first, structured data, indexability', Icon: Settings, color: '#294bfd' },
  { label: 'Content Optimization', detail: 'Target keywords, answer search intent, build topical authority', Icon: PenLine, color: '#294bfd' },
  { label: 'Local SEO + Reviews', detail: 'Google Business Profile, 750+ reviews, local citations', Icon: MapPin, color: '#ff34a7' },
  { label: 'Rankings Improve', detail: 'Page 2 → Page 1 (3-6 months for competitive terms)', Icon: TrendingUp, color: '#ff34a7' },
  { label: 'Organic Traffic Grows', detail: 'Compounding — each page builds domain authority for the next', Icon: Rocket, color: '#10b981' },
  { label: 'Leads at $0 CPL', detail: 'Convert 5-15% of organic visitors into qualified leads', Icon: DollarSign, color: '#10b981' },
];

export function SEOPerformanceFlow() {
  return (
    <ShareableChart title="SEO to Leads - The Performance Path">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        The SEO Path: From Optimization to Leads
      </h3>
      <p className="text-sm text-gray-500 mb-6" style={{ fontFamily: FONT_TEXT }}>
        SEO isn't instant — but it compounds. Every month builds on the last.
      </p>

      <div className="space-y-3">
        {steps.map((step, i) => (
          <div key={step.label} className="flex items-start gap-4">
            {/* Step number + connector */}
            <div className="flex flex-col items-center flex-shrink-0">
              <div 
                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm"
                style={{ backgroundColor: step.color, fontFamily: FONT_TEXT }}
              >
                {i + 1}
              </div>
              {i < steps.length - 1 && (
                <div className="w-0.5 h-6 bg-gray-200 mt-1" />
              )}
            </div>
            {/* Content */}
            <div className="pt-1.5">
              <div className="flex items-center gap-2">
                <step.Icon size={16} aria-hidden="true" className="shrink-0" />
                <h4 className="font-semibold text-gray-900 text-sm" style={{ fontFamily: FONT_TEXT }}>{step.label}</h4>
              </div>
              <p className="text-sm text-gray-500 mt-0.5" style={{ fontFamily: FONT_TEXT }}>{step.detail}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-4" style={{ fontFamily: FONT_TEXT }}>
        Source: leadpops.com · Timeline varies by market competition and starting authority
      </p>
    </ShareableChart>
  );
}
